import * as React from 'react';

import { cn } from '@/lib/ui-kit/utils';

interface YesNoButtonProps extends React.ComponentProps<'button'> {
  variant: 'yes' | 'no' | 'neutral';
  active?: boolean;
}

function YesNoButton({ variant, active = false, className, children, ...props }: YesNoButtonProps) {
  return (
    <button
      data-slot="yes-no-button"
      className={cn(
        'relative inline-flex h-[46px] w-[140px] cursor-pointer select-none items-center justify-center gap-2 overflow-hidden rounded-[10px] px-5 py-3 text-center text-[16px] leading-[22px] whitespace-nowrap transition-colors duration-150 disabled:pointer-events-none disabled:opacity-50',
        'font-medium',
        variant === 'yes' &&
          (active
            ? 'bg-v2-toggle-green-surface text-v2-green'
            : 'bg-v2-btn-secondary text-green-400-40 hover:text-v2-green'),
        variant === 'no' &&
          (active
            ? 'bg-v2-toggle-red-surface text-red-400'
            : 'bg-v2-btn-secondary text-red-400-50 hover:text-red-400'),
        variant === 'neutral' && [
          'bg-v2-bg-blue-10',
          active ? 'text-v2-bg-blue' : 'text-v2-bg-blue/60 hover:text-v2-bg-blue',
        ],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export { YesNoButton };
